// Maaş Ödemeleri tablosunun sütunları (eski tablonun 14 sütunu; ad ve soyad
// başa alınıp sabitlendi). Metinler: salaryPayment.columns.<key>.

export const MONEY_KEYS = [
  'grossSalary',
  'sskEmployeeShare',
  'unemploymentEmployeeShare',
  'stampTax',
  'totalDeductions',
  'netSalary',
  'sskEmployerShare',
  'unemploymentEmployerShare',
  'suggestedCost',
];

export const PAYMENT_COLUMNS = {
  employeeName: { type: 'text', width: 170 },
  employeeSurname: { type: 'text', width: 170 },
  isCurrentMonthPaid: { type: 'select', width: 175 },
  lastPaymentDate: { type: 'date', width: 195 },
  grossSalary: { type: 'text', width: 150 },
  sskEmployeeShare: { type: 'text', width: 180 },
  unemploymentEmployeeShare: { type: 'text', width: 210 },
  stampTax: { type: 'text', width: 150 },
  totalDeductions: { type: 'text', width: 170 },
  netSalary: { type: 'text', width: 150 },
  sskEmployerShare: { type: 'text', width: 200 },
  unemploymentEmployerShare: { type: 'text', width: 230 },
  suggestedCost: { type: 'text', width: 160 },
  contractDate: { type: 'date', width: 160 },
};

export const COLUMN_KEYS = Object.keys(PAYMENT_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['employeeName', 'employeeSurname'];

// Durum anahtarı ('' hepsi, 'true' ödendi, 'false' ödenmedi)
export const PAID_VALUES = ['', 'true', 'false'];

export const getCurrentYearMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
